import { Link } from "react-router-dom";
import { ArrowRight, ShoppingCart } from "lucide-react";

const base =
    "inline-flex items-center justify-center gap-2 rounded-lg font-semibold text-sm sm:text-base px-6 py-3 transition-[transform,background-color,color,box-shadow,border-color] duration-300 hover:-translate-y-0.5";

const variants = {
    gold: "bg-[#C9A227] text-[#0B1F3A] hover:bg-[#D4AF37] shadow-[0_12px_30px_-12px_rgba(201,162,39,0.8)]",
    navy: "bg-[#0B1F3A] text-white hover:bg-[#122B4A]",
    outlineLight: "border border-white/70 text-white hover:bg-white hover:text-[#0B1F3A]",
    outlineNavy: "border-2 border-[#0B1F3A] text-[#0B1F3A] hover:bg-[#0B1F3A] hover:text-white",
    outlineGold: "border-2 border-[#C9A227] text-[#C9A227] hover:bg-[#C9A227] hover:text-[#0B1F3A]",
};

export const Btn = ({
    variant = "gold",
    to,
    href,
    testid,
    className = "",
    children,
    arrow = true,
    cart = false,
    onClick,
}) => {
    const cls = `${base} ${variants[variant]} ${className}`;
    const content = (
        <>
            {cart && <ShoppingCart className="h-4 w-4" />}
            <span>{children}</span>
            {arrow && <ArrowRight className="h-4 w-4" />}
        </>
    );
    if (href)
        return (
            <a data-testid={testid} href={href} target="_blank" rel="noopener noreferrer" className={cls}>
                {content}
            </a>
        );
    if (to)
        return (
            <Link data-testid={testid} to={to} className={cls}>
                {content}
            </Link>
        );
    return (
        <button type="button" data-testid={testid} onClick={onClick} className={cls}>
            {content}
        </button>
    );
};

export const Eyebrow = ({ children, light = false, className = "" }) => (
    <p className={`eyebrow ${light ? "text-[#D4AF37]" : ""} ${className}`}>{children}</p>
);

export const PageHero = ({ eyebrow, title, sub, image, testid }) => (
    <section data-testid={testid} className="relative overflow-hidden bg-[#0B1F3A]">
        {image && (
            <>
                <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-35" />
                <div className="absolute inset-0 bg-gradient-to-r from-[#08162A] via-[#0B1F3A]/85 to-[#0B1F3A]/40" />
            </>
        )}
        <div className="relative mx-auto max-w-6xl px-6 py-20 sm:py-28">
            <Eyebrow light>{eyebrow}</Eyebrow>
            <h1 className="mt-3 max-w-3xl text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white">
                {title}
            </h1>
            {sub && <p className="mt-5 max-w-2xl text-base sm:text-lg text-white/80 leading-relaxed">{sub}</p>}
        </div>
    </section>
);
